import { VoidCallback1 } from '@deqo/foundation';


const cache = new WeakMap<VoidCallback1<any>, any>();

function createHandlers(callback: VoidCallback1<any>) {

    let handler = cache.get(callback);

    if (!handler) {
        const state = {} as any;

        handler = {
            callback,
            touchStart(e: any) {
                if (e.defaultPreed) {
                    return;
                }
                clearTimeout(state.touchTimeout);
                state.touchClick = true;
                callback(e);
            },
            touchEnd(_e: any) {
                if (state.touchClick) {
                    state.touchTimeout = setTimeout(() => {
                        state.touchClick = false;
                        state.touchTimeout = null;
                    }, 300);
                }
            },
            click(e: any) {
                if (e.defaultPrevented || state.touchClick) {
                    return;
                }
                callback(e);
            }
        };

        cache.set(callback, handler);
    }

    return handler;
}

export function tapOrClick(callback?: VoidCallback1<any>, props?: any) {
    if (!callback) return {};
    const p = (props || {});
    const handlers = createHandlers(callback);
    p.onTouchStart = handlers.touchStart;
    p.onTouchEnd = handlers.touchEnd;
    p.onClick = handlers.click;
    return p;
}
